import { takeLatest, call, put, all, select } from 'redux-saga/effects';

import { TASK_STATUSES } from 'modules/tasks/data/constants';

import taskService, { transformFiltersParamsToApi } from 'services/taskService';

import { fetchTasks, types } from './actions';
import { getPage, getPageSize, getQuoteNumberWithRevision } from './reducer';

export default function* root() {
  yield takeLatest(types.OPEN_TASK_OVERVIEW_MODAL, loadAndFetchTasks);
  yield takeLatest(types.FETCH_TASKS_REQUEST, watchFetchTasks);
  yield takeLatest(types.TASKS_PAGINATE, loadAndFetchTasks);
}

export function* loadAndFetchTasks() {
  yield put(fetchTasks.request());
}

export function* watchFetchTasks() {
  try {
    const [page, pageSize, quoteNumberWithRevision] = yield all([
      select(getPage),
      select(getPageSize),
      select(getQuoteNumberWithRevision),
    ]);
    const queryParams = transformFiltersParamsToApi({
      page,
      pageSize,
      quoteNumber: quoteNumberWithRevision,
      statusIn: [TASK_STATUSES.OPEN, TASK_STATUSES.OVERDUE],
    });
    const { count, results } = yield call(taskService.list, queryParams);
    yield put(fetchTasks.success({ openTaskCount: count, openTasks: results }));
  } catch (e) {
    yield put(fetchTasks.error(e));
  }
}
